import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import QuestListItem from '../mini/QuestListItem'
import InProgress from './InProgress'
import PriorityIndicator from '../mini/PriorityIndicator'

import { setQuestSection } from '../../actions/quest'
import { postLoggingInfo } from '../../actions/logging'
import { getDateDisplay } from '../../utils/time'
import {
  experience,
  subject,
  copy,
  standards,
  final
} from '../../utils/messages'

const PriorityIndicatorContainer = styled.div`
  position: absolute;
  top: 10px;
  display: flex;
  width: 100%;
  justify-content: center;
`

export default class ReviewQueueItem extends Component {
  constructor(props) {
    super(props)
    this.onClickBound = this.onClick.bind(this)
    this.highlightQuestNameBound = this.highlightQuestName.bind(this)
    this.unhighlightQuestNameBound = this.unhighlightQuestName.bind(this)
  }

  render() {
    const { quest, user, dispatch } = this.props
    const userHasPreviouslyReviewed = quest.reviewer_ids.indexOf(user.id) > -1
    const isOeReviewer =
      user.organization_roles.indexOf('qm_platform_review') > -1
    const cssExperience = this.getSubreviewCssClasses('experience')
    const cssSubject = this.getSubreviewCssClasses('subject')
    const cssCopy = this.getSubreviewCssClasses('copy')
    const cssStandards = this.getSubreviewCssClasses('standards')
    const cssFinal = this.getSubreviewCssClasses('final')

    // ul tag below is a hack because QuestListItem component is an li
    return (
      <li id={`review-item-${quest.id}`}>
        {this.containsOpenSubreviewByAnotherUser() && (
          <div
            className="locked-overlay"
            onClick={this.onClickBound}
            onMouseOver={this.highlightQuestNameBound}
            onMouseOut={this.unhighlightQuestNameBound}
          ></div>
        )}
        {userHasPreviouslyReviewed && (
          <div>
            <div
              className="previously-reviewed"
              data-id={quest.id}
              onMouseOver={this.onPreviouslyReviewedMouseOver}
              onMouseOut={this.onPreviouslyReviewedMouseOut}
            ></div>
            <div className="previously-reviewed-info" id={quest.id}>
              <FormattedMessage
                id={'ReviewQueue.Flagged'}
                defaultMessage={
                  'We flagged this quest because you reviewed it in the past.'
                }
              />
            </div>
          </div>
        )}
        <div className="quest-info">
          <ul>
            <QuestListItem
              quest={this.props.quest}
              clickHandler={this.onClickBound}
              isCompiledQuest
              dispatch={dispatch}
              user={user}
              iconHeightWidth={36}
            />
          </ul>
        </div>
        {!isOeReviewer && (
          <div
            className={cssExperience}
            onClick={this.onClickBound}
            data-object="experience"
          >
            {cssExperience.indexOf('in-progress') === -1 && (
              <label>{experience}</label>
            )}
            {cssExperience.indexOf('in-progress') > -1 && (
              <InProgress review={this.getReviewOfType('experience')} />
            )}
          </div>
        )}
        {!isOeReviewer && (
          <div
            className={cssSubject}
            onClick={this.onClickBound}
            data-object="subject"
          >
            {cssSubject.indexOf('in-progress') === -1 && (
              <label>{subject}</label>
            )}
            {cssSubject.indexOf('in-progress') > -1 && (
              <InProgress review={this.getReviewOfType('subject')} />
            )}
          </div>
        )}
        {!isOeReviewer && (
          <div
            className={cssCopy}
            onClick={this.onClickBound}
            data-object="copy"
          >
            {cssCopy.indexOf('in-progress') === -1 && <label>{copy}</label>}
            {cssCopy.indexOf('in-progress') > -1 && (
              <InProgress review={this.getReviewOfType('copy')} />
            )}
          </div>
        )}

        {isOeReviewer && (
          <div
            className={cssStandards}
            onClick={this.onClickBound}
            data-object="standards"
          >
            {cssStandards.indexOf('in-progress') === -1 && (
              <label>{standards}</label>
            )}
            {cssStandards.indexOf('in-progress') > -1 && (
              <InProgress review={this.getReviewOfType('standards')} />
            )}
          </div>
        )}
        {isOeReviewer && (
          <div
            className={cssFinal}
            onClick={this.onClickBound}
            data-object="final"
          >
            {cssFinal.indexOf('in-progress') === -1 && <label>{final}</label>}
            {cssFinal.indexOf('in-progress') > -1 && (
              <InProgress review={this.getReviewOfType('final')} />
            )}
          </div>
        )}
        <div className="review-info">
          {quest.priority !== 'normal' && (
            <PriorityIndicatorContainer>
              <PriorityIndicator
                priority={quest.priority}
                questId={quest.id}
                small
              />
            </PriorityIndicatorContainer>
          )}
          <div className="round">
            <FormattedMessage id={'Round'} defaultMessage={'Round'} />{' '}
            {quest.build}
          </div>
          <div className="waiting">
            <FormattedMessage id={'Waiting'} defaultMessage={'Waiting'} />{' '}
            <br />
            {getDateDisplay(quest.state_updated_at)}
          </div>
        </div>
      </li>
    )
  }

  containsOpenSubreviewByAnotherUser() {
    var retval = false

    this.props.quest.reviews.forEach(function (review) {
      if (review.created_at && !review.completed_at) {
        retval = true
      }
    })

    return retval
  }

  getSubreviewCssClasses(subreviewType) {
    const existingReview = this.getReviewOfType(subreviewType)
    var cssClasses = subreviewType

    if (existingReview && existingReview.completed_at) {
      cssClasses += ' completed'
    } else if (existingReview && !existingReview.completed_at) {
      cssClasses += ' in-progress'
    } else {
      cssClasses += ' not-started'
    }

    return cssClasses
  }

  getReviewOfType(type) {
    return this.props.quest.reviews.find(function (review) {
      return review.criteria === type
    })
  }

  highlightQuestName() {
    document
      .querySelector(`#review-item-${this.props.quest.id}`)
      .querySelector('.name')
      .classList.add('active')
  }

  unhighlightQuestName() {
    document
      .querySelector(`#review-item-${this.props.quest.id}`)
      .querySelector('.name')
      .classList.remove('active')
  }

  onClick(e) {
    e.preventDefault()
    const isOeReviewer =
      this.props.user.organization_roles.indexOf('qm_platform_review') > -1

    this.props.dispatch(
      setQuestSection('questreview', null, e.currentTarget.dataset.object)
    )
    this.props.dispatch(push(`/quest/${this.props.quest.quest_id}/questreview`))

    const clickTarget = e.currentTarget.dataset.object
      ? e.currentTarget.dataset.object
      : `${isOeReviewer ? 'oe' : 'internal'}queue_quest_name`

    this.props.dispatch(
      postLoggingInfo('review_queue', {
        action: 'click',
        click_target: clickTarget
      })
    )
  }

  onPreviouslyReviewedMouseOver(e) {
    document.getElementById(e.currentTarget.dataset.id).classList.add('active')
  }

  onPreviouslyReviewedMouseOut(e) {
    document
      .getElementById(e.currentTarget.dataset.id)
      .classList.remove('active')
  }
}

ReviewQueueItem.propTypes = {
  quest: PropTypes.object,
  user: PropTypes.object,
  dispatch: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/reviewqueue/Item.js